export default __webpack_public_path__ + "static/media/Camion.b7a838c6.svg";